module.exports = __webpack_public_path__ + "img/gruppen_diagnose_01.66e2ede9.png";